exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.iconfont[data-v-31ea41b3] {\n  font-size: 14px;\n  color: #fff;\n  margin-right: 6px;\n}\n", ""]);

// exports
